import { AbstractModel } from "@gipi-pages/abstract/models/abstract.model";

export class ConfigurationModel extends AbstractModel {

    /** Quantidade máxima de extensão de licença mensal */
    maximumQuantityOfMonthlyLicenseExtension: number;

}
